export const SPECIALITY = "speciality";
export const MEDICAL_PROCEDURE = "medical_procedure";
